import React, { useEffect, useState } from 'react';
import Joyride from 'react-joyride';
import OnBoardingTooltip from '@teetsh/app/src/components/OnBoardingTooltip';
import H1 from '@teetsh/app/src/components/Typography/Headings/H1';
import { useOnboardingEleves } from '@teetsh/app/src/containers/Eleves/useOnboardingEleves';
import tw, { css } from 'twin.macro';
import { buildYoutubeEmbedUrl, tutoUrls } from 'containers/tutoUrls';
import { useTranslation } from 'react-i18next';
import { useIsBelowBreakpoint } from 'components/ResponsiveSwitcher/useIsBelowSize';

export function Onboarding() {
  const { disableOnboarding, onFinish, isOpen } = useOnboardingEleves();
  const { t } = useTranslation(['eleve', 'common']);
  const isMobile = useIsBelowBreakpoint('md');
  const [ride, setRide] = useState<any>({
    steps: [
      {
        target: 'body',
        content: (
          <div>
            <div tw="text-center mb-4">
              <div tw="text-7xl mb-4">👋</div>
              <H1 tw="mb-8">{t('eleve:onboarding.title')}</H1>
            </div>
            <div tw="text-center mb-4">
              <span tw="text-xl mb-8">{t('eleve:onboarding.description')}</span>
              <div
                css={[
                  tw`relative h-0 mt-8`,
                  css`
                    padding-bottom: 56.25%;
                  `,
                ]}
              >
                <iframe
                  css={[tw`absolute top-0 left-0 w-full h-full border-0`]}
                  src={buildYoutubeEmbedUrl(
                    tutoUrls.eleveVideoTutorialEmbedUrl,
                    {
                      lng: t('common:locale.short'),
                      forceSubtitles:
                        isMobile || t('common:locale.short') !== 'fr',
                    },
                  )}
                  allowFullScreen
                  allowTransparency
                ></iframe>
              </div>
            </div>
          </div>
        ),
        hideBackButton: true,
        disableBeacon: true,
        locale: {
          forceNext: t('eleve:onboarding.next'),
        },
        preventFurtherDisplayFct: async () => {
          disableOnboarding();
        },
        placement: 'center',
        floaterProps: {
          styles: {
            floater: {
              overflowY: 'auto',
              height: '100%',
              // width: '100%',
            },
          },
        },
      },
    ],
  });
  useEffect(() => {
    setRide({ ...ride, run: isOpen });
  }, []);

  // Le disableScrollParentFix est important
  // sinon ça ajoute un overflow inherit au parent
  // ce qui peut fuck complètement overflow du parent ...
  return (
    <Joyride
      disableScrollParentFix
      disableScrolling
      steps={ride.steps as any}
      run={isOpen}
      tooltipComponent={props => <OnBoardingTooltip joyrideProps={props} />}
      locale={{
        skip: 'Passer',
        close: 'Suivant',
        next: 'Suivant',
        back: 'Précédent',
        last: "C'est compris !",
      }}
      callback={data => {
        const { status } = data;
        if (status === 'finished') {
          onFinish();
        }
      }}
    />
  );
}
